import * as React from 'react';

import { PageLayout } from '../../components/PageLayout';
import { Desktop } from '../../../packages/Responsive';
import { Map } from '../Map';
import { NavigationContainer } from '../Navigation';
import { SaveSearchModalContainer } from '../SaveSearchModalContainer';
import { Notifications } from '../Notifications';
import { FiltersContainer } from '../FiltersContainer';
import { SidebarContainer } from '../SidebarContainer';
import { MortgageBannerContainer } from '../MortgageBannerContainer';

export function PageContainer() {
  return (
    <>
      <PageLayout
        navigation={
          <>
            <Desktop>
              <FiltersContainer />
            </Desktop>
            <NavigationContainer />
          </>
        }
        sidebar={
          <Desktop>
            <SidebarContainer />
          </Desktop>
        }
        map={<Map />}
      />
      <MortgageBannerContainer />
      <SaveSearchModalContainer />
      <Notifications />
    </>
  );
}
